import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const pageAccessGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const pageKey = String(route.data?.['pageKey'] ?? '').trim();

  if (pageKey === '' || auth.canAccessPage(pageKey)) {
    return true;
  }

  const fallbackRoute = auth.defaultAccessibleRoute();

  return router.parseUrl(fallbackRoute ?? '/sin-acceso');
};
